/** Clamp a completion percentage to the 0–100 integer range. */
export function clampPercent(n) {
  const x = Number(n);
  if (Number.isNaN(x)) return 0;
  return Math.max(0, Math.min(100, Math.round(x)));
}

/** Title-case a snake_case or lowercase tag/difficulty value, e.g. `computer_science` -> `Computer Science`. */
export function titleCase(s = '') {
  return String(s)
    .toLowerCase()
    .replace(/^.|_./g, (m, i) => (i === 0 ? m.toUpperCase() : ' ' + m.slice(1).toUpperCase()));
}
